import { HttpHeaders } from '@angular/common/http';

export const LoadingHeaders = {
    httpHeadersWithNoLoading(): HttpHeaders {
         return new HttpHeaders({
            'Content-Type': 'application/json',
            'No-Loading': 'true'
        });
    }
}